const STEPS = [
  {
    num: '1',
    emoji: '\uD83D\uDC8A',
    title: 'Add your medications',
    desc: 'Search 100,000+ prescription and OTC drugs by name, or scan a barcode on mobile.',
  },
  {
    num: '2',
    emoji: '\uD83E\uDDE0',
    title: 'We analyze every pair',
    desc: 'AI cross-references official FDA drug-label data against your full medication list.',
  },
  {
    num: '3',
    emoji: '\uD83C\uDFA8',
    title: 'See it color-coded',
    desc: 'Every alert is rated severity (severe / moderate / minor / none) with a plain-English explanation and a clear recommendation.',
  },
  {
    num: '4',
    emoji: '\uD83D\uDCE4',
    title: 'Track and share',
    desc: 'Log doses, get scheduled reminders, and export a one-page summary your doctor can read in 30 seconds.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 scroll-mt-20" style={{ backgroundColor: '#E8F4F4' }} data-testid="landing-how-it-works">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12" style={{ color: '#5B2D1F' }}>
          How it works
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s) => (
            <div key={s.num} className="rounded-2xl p-6" style={{ backgroundColor: '#FFFFFF' }} data-testid={`landing-step-${s.num}`}>
              <div className="flex items-center gap-3 mb-3">
                <span
                  className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-extrabold text-white"
                  style={{ backgroundColor: '#D77A52' }}
                >
                  {s.num}
                </span>
                <span className="text-2xl" role="img" aria-hidden="true">{s.emoji}</span>
              </div>
              <h3 className="text-lg font-extrabold mb-1" style={{ color: '#5B2D1F' }}>{s.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#6B4A3A' }}>{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <img
            src="/brand/how-it-works.png"
            alt="Three-vignette illustration showing the Heritage Compass workflow"
            className="w-full max-w-3xl h-auto rounded-2xl"
            loading="lazy"
            data-testid="landing-how-illustration"
          />
        </div>
      </div>
    </section>
  );
}
